<template>
  <div>
    <div class="flex">
      <div>
        <a-button class="top_btn" type="primary" @click="exportList()"
          >批量导出</a-button
        >
        <span style="margin-left: 8px;">
          <template v-if="hasSelected">
            {{ `选中 ${selectedRowKeys.length} 项` }}
          </template>
        </span>
      </div>
      <div class="search-group flex">
        <a-input
          v-model="search.name"
          class="search-input"
          allowClear
          placeholder="请输入客户名称搜索"
        />
        <a-button type="primary" class="top_btn" @click="getList()"
          >搜索</a-button
        >
        <!--                <a-button type="danger" class="top_btn" @click="empty">清空</a-button>-->
      </div>
    </div>
    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="pagination"
      rowKey="id"
      @change="handleChange"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :scroll="{ x: 1500 }"
    >
    </a-table>
  </div>
</template>

<script>
import API from "./api";

const columns = [
  {
    title: "客户名称",
    key: "company",
    ellipsis: true,
    dataIndex: "company",
    width: "180px",
  },
  {
    title: "翻译购买量",
    key: "translation_num",
    ellipsis: true,
    width: "180px",
    dataIndex: "translation_num",
    sorter: true,
  },
  {
    title: "翻译使用量",
    key: "translation_use_num",
    ellipsis: true,
    width: "180px",
    dataIndex: "translation_use_num",
    sorter: true,
  },
  // {
  //     title: "翻译剩余量",
  //     key: "translation_surplus_num",
  //     ellipsis: true,
  //     dataIndex: "translation_surplus_num",
  //     sorter: true,
  // },
  {
    title: "Facebook使用数/总数",
    key: "fb_summary",
    ellipsis: true,
    width: "180px",
    dataIndex: "fb_summary",
    sorter: true,
  },
  {
    title: "LinkedIn使用数/总数",
    key: "linkedin_summary",
    ellipsis: true,
    width: "180px",
    dataIndex: "linkedin_summary",
    sorter: true,
  },
  {
    title: "Google地图使用数/总数",
    key: "google_map_summary",
    ellipsis: true,
    width: "195px",
    dataIndex: "google_map_summary",
    sorter: true,
  },
  {
    title: "搜索引擎使用数/总数",
    key: "search_engine_summary",
    ellipsis: true,
    width: "180px",
    dataIndex: "search_engine_summary",
    sorter: true,
  },
  {
    title: "WhatsApp挖掘使用数/总数",
    key: "whatsapp_summary",
    ellipsis: true,
    width: "200px",
    dataIndex: "whatsapp_summary",
    sorter: true,
  },
  {
    title: "企业信息挖掘使用数/总数",
    key: "enterprise_summary",
    ellipsis: true,
    width: "200px",
    dataIndex: "enterprise_summary",
    sorter: true,
  },
  {
    title: "Facebook监控使用数/总数",
    key: "fb_watch_summary",
    ellipsis: true,
    width: "200px",
    dataIndex: "fb_watch_summary",
    sorter: true,
  },
  {
    title: "关键词使用数/总数",
    key: "keyword_summary",
    ellipsis: true,
    width: "180px",
    dataIndex: "keyword_summary",
    sorter: true,
  },
  {
    title: "AI图片优化",
    key: "ai_optimize_summary",
    ellipsis: true,
    width: "140px",
    dataIndex: "ai_optimize_summary",
    sorter: true,
  },
  {
    title: "AI抠图",
    key: "ai_image_matting_summary",
    ellipsis: true,
    width: "140px",
    dataIndex: "ai_image_matting_summary",
    sorter: true,
  },
  {
    title: "AI视频生成",
    key: "ai_video_summary",
    width: "140px",
    ellipsis: true,
    dataIndex: "ai_video_summary",
    sorter: true,
  },
  {
    title: "视频自定义分割",
    key: "segmentation_summary",
    width: "140px",
    ellipsis: true,
    dataIndex: "segmentation_summary",
    sorter: true,
  },
  {
    title: "AI员工获客的统计/条",
    key: "ai_image_matting_summary",
    width: "170px",
    ellipsis: true,
    dataIndex: "ai_image_matting_summary",
    sorter: true,
  },{
    title: "智能客服使用数/总数",
    key: "customer_service_summary",
    width: "170px",
    ellipsis: true,
    dataIndex: "customer_service_summary",
    sorter: true,
  },
];
export default {
  name: "index",
  data() {
    return {
      visibleForm: false,
      titleForm: "",
      loading: true,
      editId: null,
      data: [],
      selectedRowKeys: [], // Check here to configure the default column
      columns,
      name: "",
      search: {
        name: "",
        order_field: "",
        order_sort: "",
      },
      page: 1,
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
      },
    };
  },
  created() {
    this.$store.state.adminleftnavnum = "/DataStatistics/PaymentFunction"; //设置左侧导航2-2 active
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    handleChange(pagination, filters, sorter) {
      // this.filteredInfo = filters;
      // this.sortedInfo = sorter;
      if (sorter.order) {
        let sort = sorter.order == "ascend" ? "ASC" : "DESC";
        this.search.order_field = sorter.columnKey;
        this.search.order_sort = sort;
      } else {
        delete this.search.order_field;
        delete this.search.order_sort;
      }
      let seachData = JSON.parse(JSON.stringify(this.search));
      this.name = this.search.name;
      API.service
        .GET_LIST({ page: this.page || 1, ...seachData })
        .then((res) => {
          this.data = res.data.data.data;
          this.pagination.total = res.data.data.total;
          this.pagination.pageSize = res.data.data.per_page;
          this.pagination.current = res.data.data.current_page;
          this.selectedRowKeys = [];
          this.loading = false;
        });
    },
    exportList() {
      let seachData = JSON.parse(JSON.stringify(this.search));
      API.service
        .EXPORT({ ids: this.selectedRowKeys, page: this.page, ...seachData })
        .then((res) => {
          window.open(
            `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`
          );
        });
    },
    getList(page) {
      this.page = page;
      let seachData = JSON.parse(JSON.stringify(this.search));
      this.name = this.search.name;
      API.service.GET_LIST({ page: page || 1, ...seachData }).then((res) => {
        this.data = res.data.data.data;
        this.pagination.total = res.data.data.total;
        this.pagination.pageSize = res.data.data.per_page;
        this.pagination.current = res.data.data.current_page;
        this.selectedRowKeys = [];
        this.loading = false;
      });
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.inputs {
  display: inline-block;
  width: 70px;
}
.search-group {
  float: right;
}
.search-group .search-input {
  width: 200px;
  height: 32px;
  margin: 0 8px 0 0;
}
.button-group {
  float: left;
}
#list_order {
  width: 50px;
}
.top .flex {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 16px;
  box-sizing: border-box;
  width: 60%;
  margin-bottom: 20px;
}
</style>
